module.exports = "/_next/static/images/game-1-phone-uv-frame-08b6b6484a9930bf0e76af44b685e1a9.png";